const REVEAL_CLASS = 'reveal';
const REVEAL_VISIBLE_CLASS = 'visible';

function initializeRevealAnimations(rootEl = document) {
  const revealElements = rootEl.querySelectorAll(`.${REVEAL_CLASS}:not(.${REVEAL_VISIBLE_CLASS})`);
  if (revealElements.length === 0) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealElements.forEach((element) => element.classList.add(REVEAL_VISIBLE_CLASS));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(REVEAL_VISIBLE_CLASS);
        observerInstance.unobserve(entry.target);
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }
  );

  revealElements.forEach((element) => observer.observe(element));
}

function initializeLuxuryMegaMenu(rootEl = document) {
  const header = rootEl.querySelector('.header--grid-luxury') || document.querySelector('.header--grid-luxury');
  const trigger = rootEl.querySelector('.header-luxury-nav__item--has-mega') || document.querySelector('.header-luxury-nav__item--has-mega');
  const megaMenu = rootEl.querySelector('.header-mega-menu') || document.querySelector('.header-mega-menu');
  if (!header || !trigger || !megaMenu) return;

  const syncMegaMenuTop = () => {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    const headerRect = header.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    header.style.setProperty('--luxury-mega-menu-top', `${triggerRect.bottom - headerRect.top}px`);
  };

  syncMegaMenuTop();
  window.addEventListener('resize', syncMegaMenuTop);
  window.addEventListener('scroll', syncMegaMenuTop, { passive: true });
  trigger.addEventListener('mouseenter', syncMegaMenuTop);
  header.addEventListener('focusin', syncMegaMenuTop);

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(syncMegaMenuTop);
    observer.observe(header);
    observer.observe(trigger);
  }
}

function initializeHeroScroll(rootEl = document) {
  const scrollButtons = rootEl.querySelectorAll('[data-hero-scroll]');
  if (scrollButtons.length === 0) return;

  scrollButtons.forEach((button) => {
    if (button.dataset.heroScrollBound === 'true') return;
    button.dataset.heroScrollBound = 'true';

    button.addEventListener('click', () => {
      const heroSection = button.closest('.hero-cinematic');
      const nextSection = heroSection?.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
    });
  });
}

window.initializeRevealAnimations = initializeRevealAnimations;

window.addEventListener('DOMContentLoaded', () => {
  initializeRevealAnimations();
  initializeLuxuryMegaMenu();
  initializeHeroScroll();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeRevealAnimations(event.target);
    initializeLuxuryMegaMenu(event.target);
    initializeHeroScroll(event.target);
  });
}
